export const strip_html_regex = /(<([^>]+)>|(&(nbsp|ensp|emsp|emsp13|numsp|puncsp|thinsp|hairsp[^;])+;)+)/gi;

export default (string = ``) => string.replace(strip_html_regex, ``);
